global.React = require('react')
global.ReactDOM = require('react-dom')
global.createReactClass = require('create-react-class')
global.LinkedInput = require('react-linked-input')
global.Router = require('react-router-dom').BrowserRouter
global.Route = require('react-router-dom').Route
global.Link = require('react-router-dom').Link
global.Switch = require('react-router-dom').Switch
global.HashRouter = require('react-router-dom').HashRouter
